import React, { useCallback, useEffect, useRef } from 'react';

const AUTOSAVE_INTERVAL = 300000;

const PolicyAutosave: React.FC = React.memo(() => {
  const timerRef = useRef<NodeJS.Timeout | null>(null); // Initialize timerRef

  const clearTimer = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  }, []);

  const resetTimer = useCallback(() => {
    clearTimer();
    timerRef.current = setTimeout(() => {
      document.body.dispatchEvent(new Event('auto-save-policy'));
      resetTimer();
    }, AUTOSAVE_INTERVAL);
  }, [clearTimer]);

  useEffect(() => {
    resetTimer();

    return () => clearTimer(); // Cleanup on unmount
  }, []);

  return null;
});

export default PolicyAutosave;
